var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_146737",
    "data-name": "Group 146737",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_50100",
    "data-name": "Path 50100",
    d: "M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0ZM8,15a7,7,0,1,1,7-7,7.008,7.008,0,0,1-7,7Z",
    fill: "#80838e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50101",
    "data-name": "Path 50101",
    d: "M208.818,83.118h-1.024v5.333l3.223,3.223.724-.724-2.923-2.923Z",
    transform: "translate(-200.352 -80.197)",
    fill: "#80838e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.0fe7e2336f202cd3bd71377e543f0908.svg";
export { ForwardRef as ReactComponent };